import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { NewContractPageInitialData } from "./newContractPageInitialData";

export const NEW_CONTRACT_PAGE_ID = "my-account/new-contract";

export const newContractPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.newContract(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<NewContractPageInitialData>>(`/page-data/${NEW_CONTRACT_PAGE_ID}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
